import SuccessIcon from '@bloomreach/banana-theme/icons/check-filled.svg?react';
import CloseIcon from '@bloomreach/banana-theme/icons/close.svg?react';
import ErrorIcon from '@bloomreach/banana-theme/icons/error-fill.svg?react';
import InfoIcon from '@bloomreach/banana-theme/icons/info-filled.svg?react';
import WarningIcon from '@bloomreach/banana-theme/icons/warning-fill.svg?react';
import classnames from 'classnames';

import { Button } from '../../buttons';

import type { AlertProps, AlertType } from './alert.types';

import './alert.scss';

const defaultIconMapping: {
  [key in AlertType]: (props?: React.SVGProps<SVGSVGElement> & { title?: string | undefined }) => JSX.Element;
} = {
  error: (props) => <ErrorIcon {...props} />,
  info: (props) => <InfoIcon {...props} />,
  success: (props) => <SuccessIcon {...props} />,
  warning: (props) => <WarningIcon {...props} />,
};

function Alert(props: AlertProps): JSX.Element {
  const {
    actions,
    children,
    className,
    icon,
    onClose,
    role = 'alert',
    type = 'info',
    ...rest // Capture any other properties to pass them to the root element, like `aria-*`, `data-*`, etc.
  } = props;

  return (
    <div className={classnames(`rbui-alert rbui-alert--${type}`, className)} role={role} {...rest}>
      {icon !== false ? (
        <div className={`rbui-alert__icon rbui-alert__icon--${type}`}>{icon || defaultIconMapping[type]()}</div>
      ) : null}
      <div className="rbui-alert__content">
        {children}
        {actions ? <div className="rbui-alert__actions">{actions}</div> : null}
      </div>
      {onClose ? (
        <Button
          aria-label="Close"
          className="rbui-alert__close"
          onClick={() => onClose()}
          startIcon={<CloseIcon />}
          type="tertiary"
        />
      ) : null}
    </div>
  );
}

export default Alert;
